var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5L2.125 12.5C2.15469 13.0778 2.575 13.5 3.125 13.5H8.875C9.42719 13.5 9.83969 13.0778 9.875 12.5L10.5 2.5M0.5 2.5H11.5M4 2.5V1.25C3.99971 1.15143 4.01891 1.05377 4.0565 0.962649C4.09409 0.871525 4.14932 0.788731 4.21903 0.719029C4.28873 0.649328 4.37152 0.594094 4.46265 0.556505C4.55377 0.518917 4.65143 0.499714 4.75 0.500003H7.25C7.34857 0.499714 7.44623 0.518917 7.53735 0.556505C7.62848 0.594094 7.71127 0.649328 7.78097 0.719029C7.85068 0.788731 7.90591 0.871525 7.9435 0.962649C7.98109 1.05377 8.00029 1.15143 8 1.25V2.5M6 4.5V11.5M3.75 4.5L4 11.5M8.25 4.5L8 11.5",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.01c62279cecba8ee08d167ae6736dc66.svg";
export { ForwardRef as ReactComponent };